import React, { useMemo } from 'react';
import KanbanColumn from './KanbanColumn';
import OperationCard from '../OperationCard';

/**
 * Columna "Cotizaciones" — agrupa solicitudes en estado `Borrador`.
 *
 * Archivo independiente para que se pueda modificar sin tocar
 * las otras 3 columnas (EnCurso, Finalizadas, Rechazadas).
 */
const CotizacionesColumn = ({ items = [], onAction, loading = false, headerExtra, actionsMode = 'full' }) => {
  // `renderItem` se memoriza para no recrearlo en cada render del padre
  const renderItem = useMemo(
    () => (r) => <OperationCard r={r} variant="cotizaciones" onAction={onAction} actionsMode={actionsMode} />,
    [onAction, actionsMode],
  );

  return (
    <KanbanColumn
      id="cotizaciones"
      title="Cotizaciones"
      accent="border-t-amber-400"
      badge="bg-amber-100 text-amber-800 border-amber-200"
      items={items}
      renderItem={renderItem}
      loading={loading}
      emptyText="Sin cotizaciones en borrador"
      headerExtra={headerExtra}
    />
  );
};

export default CotizacionesColumn;
